// "use client";

// import { useState, useEffect } from "react";
// import logo from "../../assets/img/logo/logo.jpg";

// const Particles = () => {
//   return (
//     <div
//       style={{
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         overflow: "hidden",
//         zIndex: 0,
//       }}
//     >
//       {[...Array(20)].map((_, i) => (
//         <div
//           key={i}
//           style={{
//             position: "absolute",
//             width: "10px",
//             height: "10px",
//             background: "rgba(255, 182, 193, 0.5)",
//             borderRadius: "50%",
//             top: `${Math.random() * 100}%`,
//             left: `${Math.random() * 100}%`,
//             animation: `float ${Math.random() * 20 + 10}s infinite linear ${
//               Math.random() * 5
//             }s`,
//           }}
//         />
//       ))}
//     </div>
//   );
// };

// const Index = () => {
//   const [email, setEmail] = useState("");
//   const [isButtonHovered, setIsButtonHovered] = useState(false);
//   const [isInputHovered, setIsInputHovered] = useState(false);

//   const [hoveredSocial, setHoveredSocial] = useState(null);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert(`Thank you for your interest! We'll notify you at ${email}`);
//     setEmail("");
//   };

//   // Inline styles
//   const styles = {
//     app: {
//       height: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "2rem 1rem",
//       background: "white",
//       position: "relative",
//       overflow: "hidden",
//       fontFamily: "'Poppins', sans-serif",
//     },
//     content: {
//       position: "relative",
//       zIndex: 1,
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       maxWidth: "100%",
//       width: "100%",
//       height: "100vh",
//     },
//     logo: {
//       width: "150px",
//       height: "120px",
//       objectFit: "cover",
//       padding: "10px",
//       marginBottom: "50px",
//     },
//     title: {
//       fontSize: "clamp(2rem, 5vw, 3rem)",
//       fontWeight: "bold",
//       color: "#FFB6C1",
//       marginBottom: "10px",
//       textAlign: "center",
//       textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#666",
//       marginBottom: "50px",
//       textAlign: "center",
//       maxWidth: "600px",
//     },

//     form: {
//       width: "100%",
//       maxWidth: "400px",
//       marginBottom: "100px",
//     },
//     inputWrapper: {
//       display: "flex",
//       borderRadius: "2rem",
//       overflow: "hidden",
//       boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//     },
//     input: {
//       flexGrow: 1,
//       backgroundColor: "white",
//       border: "none",
//       color: "#333",
//       fontSize: "1rem",
//       padding: "0.75rem 1.5rem",
//       outline: "none",
//     },

//     button: {
//       backgroundColor: isButtonHovered ? "#FFC1CC" : "#FFB6C1",
//       color: "white",
//       border: "none",
//       padding: "0.75rem 1.5rem",
//       fontSize: "1rem",
//       cursor: "pointer",
//       transition: "background-color 0.3s, transform 0.1s",
//     },
//     socialLinks: {
//       display: "flex",
//       gap: "0px",
//       marginTop: "auto",
//       paddingBottom: "2rem",
//       fontSize: "30px",
//     },
//     socialIcon: (social) => ({
//       color: hoveredSocial === social ? "#FFC1CC" : "#FFB6C1",
//       transform:
//         hoveredSocial === social ? "translateY(-3px)" : "translateY(0)",
//       transition: "color 0.3s, transform 0.3s",
//       display: "inline-flex", // Prevent unnecessary spacing
//       justifyContent: "center",
//       alignItems: "center",
//       margin: "0", // Remove any unnecessary margins
//       padding: "0", // Remove extra padding
//     }),
//   };

//   return (
//     <div style={styles.app}>
//       <Particles />

//       <div style={styles.content}>
//         <div style={styles.logo}>
//           <img
//             src={logo}
//             alt=""
//             style={{
//               width: "100%",
//               height: "100%",
//             }}
//           />
//         </div>

//         <h1 style={styles.title}>Coming Soon</h1>
//         <p style={styles.subtitle}>
//           Get ready for a beautiful transformation with RRRBeautify's exclusive
//           beauty products
//         </p>

//         <form onSubmit={handleSubmit} style={styles.form}>
//           <div style={styles.inputWrapper}>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               style={styles.input}
//             />
//             <button
//               type="submit"
//               style={styles.button}
//               onMouseEnter={() => setIsButtonHovered(true)}
//               onMouseLeave={() => setIsButtonHovered(false)}
//             >
//               Notify Me
//             </button>
//           </div>
//         </form>

//         <div style={styles.socialLinks}>
//           {[
//             {
//               name: "whatsapp",
//               url: "https://wa.me/2349135836448?text=Hello%20RRR%20Beautify!%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me?",
//               size: "80px",
//             },
//             {
//               name: "instagram",
//               url: "https://www.instagram.com/rrrbeautify?igsh=YzljYTk1ODg3Zg==",
//             },
//           ].map((social) => (
//             <a
//               key={social.name}
//               href={social.url}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={styles.socialIcon(social.name)}
//               onMouseEnter={() => setHoveredSocial(social.name)}
//               onMouseLeave={() => setHoveredSocial(null)}
//             >
//               <span
//                 style={{
//                   position: "absolute",
//                   width: "1px",
//                   height: "1px",
//                   padding: "0",
//                   margin: "-1px",
//                   overflow: "hidden",
//                   clip: "rect(0, 0, 0, 0)",
//                   whiteSpace: "nowrap",
//                   borderWidth: "0",
//                 }}
//               >
//                 {social.name}
//               </span>

//               <svg
//                 width="40"
//                 height="40"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//                 aria-hidden="true"
//               >
//                 {social.name === "whatsapp" && (
//                   <path d="M16.313 7.686a5.956 5.956 0 00-8.438 0c-2.339 2.34-2.581 5.926-.63 8.542l-1.243 4.542 4.572-1.2a5.967 5.967 0 002.5.587c3.313 0 6-2.687 6-6 0-1.593-.62-3.11-1.76-4.253zm-4.313 9.314c-.827 0-1.633-.213-2.343-.617l-.17-.1-2.714.71.73-2.66-.11-.173a4.933 4.933 0 01-.72-2.567c0-2.733 2.267-5 5-5s5 2.267 5 5-2.267 5-5 5zm2.333-3.92l-.667-.333c-.2-.1-.433-.067-.6.1l-.48.48c-.833-.333-1.533-1-1.9-1.833l.467-.5c.167-.167.2-.4.1-.6l-.333-.667a.487.487 0 00-.533-.267 1.763 1.763 0 00-1.2.967c-.3.533-.333 1.2-.1 1.8.433 1.033 1.267 1.867 2.3 2.3.2.067.4.1.6.1.4 0 .767-.1 1.133-.267.467-.233.8-.667.933-1.167a.489.489 0 00-.253-.533z" />
//                 )}
//               </svg>

//               <svg
//                 width="24"
//                 height="24"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//                 aria-hidden="true"
//               >
//                 {social.name === "instagram" && (
//                   <path
//                     fillRule="evenodd"
//                     d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
//                     clipRule="evenodd"
//                   />
//                 )}
//               </svg>
//             </a>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Index;

"use client"

import { useState, useEffect } from "react"
import { FaWhatsapp, FaInstagram } from "react-icons/fa"
import logo from "../../assets/img/logo/logo.jpg"

const Particles = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: 0,
      }}
    >
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            width: "10px",
            height: "10px",
            background: "rgba(255, 182, 193, 0.5)",
            borderRadius: "50%",
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `float ${Math.random() * 20 + 10}s infinite linear ${Math.random() * 5}s`,
          }}
        />
      ))}
    </div>
  )
}

const Index = () => {
  const [email, setEmail] = useState("")
  const [isButtonHovered, setIsButtonHovered] = useState(false)
  const [isInputHovered, setIsInputHovered] = useState(false)

  const [hoveredSocial, setHoveredSocial] = useState(null)
  const [isMobile, setIsMobile] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault()
    alert(`Thank you for your interest! We'll notify you at ${email}`)
    setEmail("")
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    // Set initial value
    handleResize();
  
    // Add event listener
    window.addEventListener("resize", handleResize);
  
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  

  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    }

    setVh()
    window.addEventListener("resize", setVh)

    return () => window.removeEventListener("resize", setVh)
  }, [])

  // Inline styles
  const styles = {
    app: {
      minHeight: "100vh",
      minHeight: "calc(var(--vh, 1vh) * 100)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem 1rem",
      background: "white",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Poppins', sans-serif",
    },
    content: {
      position: "relative",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      maxWidth: "100%",
      width: "100%",
      height: "100vh",
    },
    logo: {
      width: "150px",
      height: "120px",
      objectFit: "cover",
      padding: "10px",
      marginBottom: "50px",
    },
    title: {
      fontSize: "clamp(2rem, 5vw, 3rem)",
      fontWeight: "bold",
      color: "#FFB6C1",
      marginBottom: "10px",
      textAlign: "center",
      textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
    },
    subtitle: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "50px",
      textAlign: "center",
      maxWidth: "600px",
    },

    form: {
      width: isMobile ? "90%" : "100%",
      maxWidth: isMobile ? "100%" : "400px",
      marginBottom: isMobile ? "50px" : "100px",
    },
    inputWrapper: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Stack on mobile
      borderRadius: "2rem",
      overflow: "hidden",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    input: {
      flexGrow: 1,
      backgroundColor: "white",
      border: "none",
      color: "#333",
      fontSize: "1rem",
      padding: "0.75rem 1.5rem",
      outline: "none",
    },

    button: {
      backgroundColor: isButtonHovered ? "#FFC1CC" : "#FFB6C1",
      color: "white",
      border: "none",
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      cursor: "pointer",
      transition: "background-color 0.3s, transform 0.1s",
      width: isMobile ? "100%" : "auto", // Full-width button on mobile
    },
    socialLinks: {
      display: "flex",
      justifyContent: "center",
      gap: "1rem",
      marginTop: "auto",
      paddingBottom: "2rem",
    },
    socialIcon: (social) => ({
      color: hoveredSocial === social ? "#FFC1CC" : "#FFB6C1",
      transform: hoveredSocial === social ? "translateY(-3px)" : "translateY(0)",
      transition: "color 0.3s, transform 0.3s",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.5rem",
      borderRadius: "50%",
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    }),
  }

  const mobileStyles = {
    content: {
      justifyContent: "space-between",
      height: "100%",
    },
    logo: {
      marginTop: "2rem",
    },
    socialLinks: {
      marginTop: "2rem",
    },
  }

  return (
    <div style={styles.app}>
      <Particles />

      <div style={{ ...styles.content, ...(window.innerWidth <= 768 ? mobileStyles.content : {}) }}>
        <div style={{ ...styles.logo, ...(window.innerWidth <= 768 ? mobileStyles.logo : {}) }}>
          <img
            src={logo || "/placeholder.svg"}
            alt=""
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>

        <h1 style={styles.title}>Coming Soon</h1>
        <p style={styles.subtitle}>
          Get ready for a beautiful transformation with RRRBeautify's exclusive beauty products
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputWrapper}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
            <button
              type="submit"
              style={styles.button}
              onMouseEnter={() => setIsButtonHovered(true)}
              onMouseLeave={() => setIsButtonHovered(false)}
            >
              Notify Me
            </button>
          </div>
        </form>

        <div style={{ ...styles.socialLinks, ...(window.innerWidth <= 768 ? mobileStyles.socialLinks : {}) }}>
          {[
            {
              name: "whatsapp",
              url: "https://wa.me/2349135836448?text=Hello%20RRR%20Beautify!%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me?",
              icon: FaWhatsapp,
            },
            {
              name: "instagram",
              url: "https://www.instagram.com/rrrbeautify?igsh=YzljYTk1ODg3Zg==",
              icon: FaInstagram,
            },
          ].map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.socialIcon(social.name)}
              onMouseEnter={() => setHoveredSocial(social.name)}
              onMouseLeave={() => setHoveredSocial(null)}
            >
              {/* <span className="sr-only">{social.name}</span> */}
              <social.icon size={24} />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Index

